let pollingIntervalId: number | null = null;
let isPollingActive = false;

/**
 * Starts the polling process.
 * @param callback - The async function to be called at each interval. This function should contain your API call.
 * @param interval - The time in milliseconds between each poll.
 */
export const startPolling = (callback: () => Promise<void>, interval = 5000) => {
  if (isPollingActive) {
    return;
  }

  isPollingActive = true;

  callback();

  pollingIntervalId = window.setInterval(callback, interval);
};

/**
 * Stops the polling process.
 */
export const stopPolling = () => {
  if (!isPollingActive || pollingIntervalId === null) {
    return;
  }

  clearInterval(pollingIntervalId);
  pollingIntervalId = null;
  isPollingActive = false;
};

/**
 * Returns the current status of the poller.
 * @returns {boolean}
 */
export const getPollingStatus = (): boolean => {
  return isPollingActive;
};
